import { render, staticRenderFns } from "./Admission.vue?vue&type=template&id=ef596778&scoped=true"
import script from "./Admission.vue?vue&type=script&lang=js"
export * from "./Admission.vue?vue&type=script&lang=js"
import style0 from "./Admission.vue?vue&type=style&index=0&id=ef596778&prod&lang=scss&scoped=true"
import style1 from "./Admission.vue?vue&type=style&index=1&id=ef596778&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef596778",
  null
  
)

export default component.exports